import { render, staticRenderFns } from "./ImgPZCTComponent.vue?vue&type=template&id=314b8ffc"
import script from "./ImgPZCTComponent.vue?vue&type=script&lang=js"
export * from "./ImgPZCTComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports